/* eslint-disable class-methods-use-this */
import React from "react";
import { get, isString, identity, isNumber } from "lodash";
import PropTypes from "prop-types";
import MediaContext from "./MediaContext";
import Store from "./Store";

const supportedHTML5VideoFormats = ["mp4", "webm", "ogg"];

class Index extends React.Component {
  constructor(...args) {
    super(...args);

    this.store = Store();
  }

  setRef = (element) => {
    if (!element) return;
    this.store.actions.pushMediaNode(element);
    let startTime = Number.parseInt(get(this, "props.startTime", 0), 10);
    let advanceToFirstHit = get(this, "props.advanceToFirstHit", 0);
    const externalHits = get(this, "props.externalHits");
    if (advanceToFirstHit && isString(advanceToFirstHit))
      advanceToFirstHit = Number.parseInt(advanceToFirstHit, 10);

    if (!startTime && advanceToFirstHit && Array.isArray(externalHits)) {
      const time = _(externalHits)
        .map("hits")
        .flatten()
        .map("s")
        .flattenDeep()
        .sortBy(identity)
        .value()[0];
      if (time && isNumber(time)) {
        startTime = time / 1000;
      }
    }

    if (startTime) {
      element.addEventListener(
        "loadedmetadata",
        function () {
          this.currentTime = startTime;
        },
        false
      );
    }
    // Split src to isolate filetype
    const elementSrcSplit = element?.src?.split(/[.?]/)
    if (
      !supportedHTML5VideoFormats.some(format => elementSrcSplit.includes(format))
    ) {
      element.style.display = "none";
    }
  };

  componentWillUnmount() {
    this.store.destroy();
  }

  render() {
    const { children, mediaUrl } = this.props;

    return (
      <>
        <video ref={this.setRef} src={mediaUrl} />
        <MediaContext.Provider value={this.store}>
          {children}
        </MediaContext.Provider>
      </>
    );
  }
}

Index.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Index;
